import * as actions from 'actions/releaseNotes'
import { fromJS } from 'immutable'
import { get } from 'utils/immutable'
import { isEmpty, prop } from 'ramda'
import { createReducer } from './utils'

export const RELEASE_NOTES_REDUX_KEY = 'releaseNotes'

export const initialState = fromJS({
  notes: [],
})

const handlers = {
  [actions.RELEASE_NOTES_REQUEST]: requestReleaseNotes,
  [actions.RELEASE_NOTES_SUCCESS]: successReleaseNotes,
  [actions.RELEASE_NOTES_FAILURE]: failureReleaseNotes,
  [actions.ADD_RELEASE_VERSION]: addReleaseVersion,
  [actions.SAVE_RELEASE_NOTE_SUCCESS]: successReleaseNotes,
}

export default createReducer(initialState, handlers)

function requestReleaseNotes(state) {
  return state
}

function successReleaseNotes(state, { data, currentVersion }) {
  const notes = !isEmpty(data)
    ? data.sort(sortReleaseNotes)
    : [{ version: currentVersion, content: 'Add an initial note...', date: '' }]

  return state.set('notes', fromJS(notes))
}

function failureReleaseNotes(state) {
  return state
}

function addReleaseVersion(state, { version }) {
  const newNote = makeNewReleaseNote(version)
  const notes = state.get('notes').push(newNote).sort(immSortReleaseNotes)

  return state.set('notes', notes)
}

const makeNewReleaseNote = (version) =>
  fromJS({
    version,
    content: 'Next Release note...',
    releaseDate: '',
  })

const immSortReleaseNotes = (a, b) => {
  const aVersion = get('version', a)
  const bVersion = get('version', b)

  if (aVersion > bVersion) return -1
  if (aVersion < bVersion) return 1
  return 0
}

const sortReleaseNotes = (a, b) => {
  const aVersion = prop('version', a)
  const bVersion = prop('version', b)

  if (aVersion > bVersion) return -1
  if (aVersion < bVersion) return 1
  return 0
}
